"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.globalIncomingQueueItemsManager = void 0;
const incoming_queue_items_manager_1 = require("./incoming-queue-items-manager");
exports.globalIncomingQueueItemsManager = new incoming_queue_items_manager_1.IncomingQueueItemsManager();
